module.exports = __webpack_public_path__ + "static/sacado-plataforma-194b3ae25f39082c3f723a23e25005ca.png";